/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const utilsModule = require('@utils/enerveeUtilsModule');

/**
 * Module for handling fast track code.
 */
const fastTrackModule = angular.module('enervee.fastTrack', [
    utilsModule.name,
]);

module.exports = fastTrackModule;